import React from "react";
import {FormControlLabel, Switch as MuiSwitch} from "@mui/material";
import {FormikProps} from "formik";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

interface Props {
    checked?: boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked:boolean) => void
    label: string|React.ReactNode
    formik?: FormikProps<any>
    name?: string
    sx?: SxProps<Theme>;
}

export function Switch({sx, formik, name, checked, onChange, label}:Props) {
    if(formik && !name) {
        alert("name not defined, while formik defined");
    }
    return <FormControlLabel
        sx={sx}
        control={
            <MuiSwitch
                checked={(formik ? formik.values[name!] : checked) || false}
                onChange={formik ? (e, c) => {formik.setFieldValue(name!, c)} : onChange}
                value={checked}
                name={name}
                color="primary"
            />
        }
        label={label}
    />
}